<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      :title="getTitle()"
      :large="true"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>

      <div class="dean-form-row">
        <div class="row">
          <div class="small-4 medium-2 large-2 hd-2 columns">
            <p class="input-label mb-0 font-weight-bold">Type</p>
          </div>
          <div class="small-8 medium-10 large-10 hd-10 columns">
            <p class="input-label mb-0">{{payloadData.type}}</p>
          </div>
        </div>
      </div>

      <div class="dean-form-row">
        <div class="row">
          <div class="small-4 medium-2 large-2 hd-2 columns">
            <p class="input-label mb-0 font-weight-bold">Created At</p>
          </div>
          <div class="small-8 medium-10 large-10 hd-10 columns">
            <p class="input-label mb-0">{{payloadData.createdAt}}</p>
          </div>
        </div>
      </div>

      <div class="dean-form-row">
        <div class="row">
          <div class="small-4 medium-2 large-2 hd-2 columns">
            <p class="input-label mb-0 font-weight-bold">Message</p>
          </div>
          <div class="small-8 medium-10 large-10 hd-10 columns">
            <p class="input-label mb-0">{{payloadData.message}}</p>
          </div>
        </div>
      </div>

      <div class="dean-form-row">
        <div class="row">
          <div class="small-4 medium-2 large-2 hd-2 columns">
            <p class="input-label mb-0 font-weight-bold">Stack Trace</p>
          </div>
          <div class="small-8 medium-10 large-10 hd-10 columns">
            <p class="input-label mb-0" style="white-space: pre-wrap;">{{ formatStackTrace(payloadData.stackTrace) }}</p>
          </div>
        </div>
      </div>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {FadeTransition} from 'vue2-transitions';
import DeanTwoColumnLayout from "@/components/deanComponents/deanTwoColumnLayout.vue";

@Component({
    components: {
      DeanTwoColumnLayout,
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class ViewLogStackTrace extends Vue {
    @Prop() public payloadData!: {
      [key: string]: {
        [key: string]: string,
      };
    };

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public created() {
      this.$emit('setLoad', false);
    }

    public getTitle(): string
    {
      return 'Logboeken ' + this.payloadData.createdAt;
    }

    public formatStackTrace(stackTrace: any): string {
      if (!stackTrace) {
        return '-';
      }

      try {
        // Attempt to parse. If it's a number or simple string, 
        // JSON.parse might succeed but we only want to format Objects/Arrays.
        const parsed = JSON.parse(stackTrace);
        if (typeof parsed === 'object' && parsed !== null) {
          return JSON.stringify(parsed, null, 4);
        }
      } catch (e) {
        // Not a valid JSON string, return as is
      }

      return stackTrace;
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container) {
  width: 70%;
}

:deep(.input-label) {
 overflow-wrap: break-word;
 word-break: break-word;
}

</style>
